export default "__VITE_ASSET__CvG_ofiI__"